import DEVICES from "../../data/dummy_device";
import Device from "../../models/device";
import {
  SET_DEVICE,
  PAIR_DEVICE,
  REMOVE_DEVICE,
  UPDATE_DEVICE_PLAYLIST,
  UPDATE_DEVICE_SETTING,
  UPDATE_DEVICE_NAME,
} from "../actions/device";
const initialState = {
  myDevices: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_DEVICE:
      return {
        myDevices: action.myDevices,
      };
    case PAIR_DEVICE:
      return {
        ...state,
        myDevices: state.myDevices.concat(action.newDevice),
      };
    case REMOVE_DEVICE:
      return {
        ...state,
        myDevices: state.myDevices.filter(
          (device) => device.deviceId !== action.device.deviceId
        ),
      };
    case UPDATE_DEVICE_PLAYLIST: {
      const deviceIndex = state.myDevices.findIndex(
        (device) => device.deviceId === action.deviceId
      );
      const oldDevice = state.myDevices[deviceIndex];
      const updatedDevice = new Device(
        oldDevice.deviceId,
        oldDevice.userId,
        oldDevice.name,
        oldDevice.settings,
        action.playlist
      );
      const updatedDevices = [...state.myDevices];
      updatedDevices[deviceIndex] = updatedDevice;
      return {
        // updateField: updateField,
        // newValue: newValue,
        ...state,
        myDevices: updatedDevices,
      };
    }
    case UPDATE_DEVICE_SETTING: {
      const deviceIndex = state.myDevices.findIndex(
        (device) => device.deviceId === action.deviceId
      );
      const oldDevice = state.myDevices[deviceIndex];
      const newSettings = oldDevice.settings;
      newSettings[action.updateField] = action.newValue;

      console.log("newsettings:", newSettings);

      const updatedDevice = new Device(
        oldDevice.deviceId,
        oldDevice.userId,
        oldDevice.name,
        newSettings,
        oldDevice.playlist
      );
      const updatedDevices = [...state.myDevices];
      updatedDevices[deviceIndex] = updatedDevice;
      return {
        // updateField: updateField,
        // newValue: newValue,
        ...state,
        myDevices: updatedDevices,
      };
    }
    case UPDATE_DEVICE_NAME: {
      const deviceIndex = state.myDevices.findIndex(
        (device) => device.deviceId === action.deviceId
      );
      const oldDevice = state.myDevices[deviceIndex];
      const updatedDevice = new Device(
        oldDevice.deviceId,
        oldDevice.userId,
        action.newName,
        oldDevice.settings,
        oldDevice.playlist
      );
      const updatedDevices = [...state.myDevices];
      updatedDevices[deviceIndex] = updatedDevice;
      return {
        ...state,
        myDevices: updatedDevices,
      };
    }
  }
  return state;
};
